<template>
  <div class="bg-white container-padding-x">
    <div class="max-w-4xl py-16 mx-auto md:py-48">
      <h3 class="text-4xl font-semibold text-center md:text-5xl">FAQs</h3>

      <div class="mt-8 accordian">
        <UtilAccordianItem>
          <template #title>How do I pay for the membership?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              You can pay on the SellMyLivestock website using a debit or credit card. We do not accept BACS or
              cheque payments. Once you sign-up for your membership, you’ll be asked for your card details via our
              secure payment system and if you choose to pay monthly, membership will be renewed and payment will
              automatically be taken monthly without you having to remember to do anything.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>Can I download my invoice for my memberships?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes of course, simply go to your account page and you’ll find your invoices under your membership
              section. You can download a copy of your membership invoice in a PDF format.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>Can I move between memberships on a monthly basis?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes you can, you can always upgrade or even downgrade your membership each month although please note
              that no refunds are given if you downgrade during the membership period. You can do this via your
              dashboard. If you require support to make changes to your membership, there will be an administration
              charge of £25 per change so we do encourage you to do this via the website.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>
            I’m paying monthly but want to switch to annual for the discount, is that possible?
          </template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes, just upgrade your monthly subscription and take out the annual version to take advantage of the
              annual discount. The date of the annual membership will start for 12 months from the day you upgrade.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>
            I’m a bronze member and want to message more people about their listings, how do I do this?
          </template>

          <template #content>
            <p class="w-full leading-relaxed">
              No problem, the easiest way to unlock the ability to send unlimited messages is to upgrade to our
              gold or silver package. You can upgrade for a month and then downgrade again if you wish to, it's not
              a problem as our packages are designed to support you when you need them. To switch packages, just go
              to your account page on our website and change your subscription. Changes are effective immediately
              so you can get in touch to buy or sell the right livestock, feed or bedding for your business.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>I’m a bronze member and want to post more listings, how do I do that?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Simply upgrade to our silver membership for unlimited listings. Also consider our gold package as not
              only do you get unlimited listings, you also get unlimited enquiries and instant access to all
              listings giving you great flexibility and value for your farming business.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How do I use the Price on Application (POA) pricing option on my listings?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Our Gold members can use the POA service, its not available for Bronze or Silver members. Once you
              have activated your membership by paying online, you will start to see the POA option appear on your
              listing and you will be able to choose to hide your prices. You will still have to tell us your price
              but we won’t publish it on the website if you prefer to show prices as price on application (POA).
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How do I see which farms are listing and where they are located?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Our Gold members have access to all of the farm details and locations. To get full visibility of who
              is listing what stock and where, simply upgrade to our Gold membership.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>Why can’t I enquire on a listing straight away?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Our Bronze and Silver members have a small restriction on when they are able to enquire on listings.
              Bronze members are restricted to 72 hours after the listing is posted and Silver members will wait 48
              hours. To get instant access to the best stock, simply upgrade to our Gold membership.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>Does my membership automatically renew?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes it does. If you’re on a monthly membership, it’ll renew automatically every month and if you
              choose an annual membership, it’ll renew automatically every year. We’ll keep you informed of any
              increases or decreases to the prices at least 30 days before a renewal so look out for any emails
              from us with details that will give you a chance to opt in or switch your membership to another plan
              if you wish to do so.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>Can I cancel my membership?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              We’re confident you’ll get value from our service however, if you do want to cancel you can do so
              online. Simply go to your account area and manage your membership there. If you have chosen to pay
              annually, memberships can only be cancelled at the end of the period. If you pay monthly, you can
              cancel your membership with 30 days notice from the last renewal date of your membership. If you do
              not cancel online (or via the App if you purchased your membership via the App) and you require the
              services of our support center to cancel your membership, you’ll be charged an additional £25
              administration fee to process the cancellation on your behalf so we do recommend cancelling online
              through your account area.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>I want to downgrade to a lower, cheaper plan, is that possible?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes, you are able to downgrade and we recommend setting yourself a diary reminder to do that right at
              the end of your current membership period because if you downgrade before, no partial refunds will be
              given either on a monthly or annual plan at all and you’ll switch straight to the lower plan with the
              associated restrictions immediately.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>I want to upgrade in the middle of my membership period, is that possible?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes, you are able to upgrade whenever you want. Our system will calculate the difference in
              membership cost for you and you’ll just pay the difference. For example, if you’re paying £69
              annually and want to upgrade your membership part way through the year, you’ll pay an additional £2.5
              per month for the remainder of your annual membership at which point you will automatically be
              renewed to the higher membership for the following year. If you are on a monthly membership, the same
              applies, you’ll pay the difference in monthly fees however if you upgrade part way through the month,
              you’ll be asked to pay the full monthly difference. For example, if you were paying £6.99 and upgrade
              part way through the month to the £9.99 package, you’ll need to pay £2 and this won’t be pro-rata for
              the part month but next month you’ll automatically be renewed to the £9.99 upgraded package.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How is my Platinum membership managed?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              With a Platinum membership, all Users under your account will have the benefits of our top plan. An
              invoice will be issued to your Finance contact, via email each month and payment will be due within 7
              days of the term renewal date. Please reach out to our Customer Support team for any adjustments to
              this plan and they will then ensure that your plan is updated in our Back end system, with no input
              required from you.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How do I get access to the members discounts and offers?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              If you’re a Silver, Gold or Platinum member, we’ll email you a link with access to all the latest
              member offers and discounts.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How long do my listings stay live?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              4 weeks is standard for all memberships however, when your listing sells, we ask you to mark that
              listing as sold so that you aren’t bombarded with enquiries you no longer need. If for some reason
              your listing has not sold within 4 weeks, if you’re a gold member and you haven’t yet marked your
              listing as sold, we’ll automatically renew it for you. If you are a bronze or silver member, your
              listing will be removed and if you want to repost it, you’ll need to add your listing again.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>
            I have two email addresses registered against my business, do I have to pay for the membership twice?
          </template>

          <template #content>
            <p class="w-full leading-relaxed">
              Yes you do. Each account is linked to an email, you are welcome to login from multiple devices such
              as your mobile and your laptop. We can not link membership to more than one email.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>
            I’m already a standard premium member with SellMylivestock at £59.99 a year, do I continue to get the
            same benefits I signed up for before you changed these packages?
          </template>

          <template #content>
            <p class="w-full leading-relaxed">
              We will endeavor to get you onto the best membership suited to your needs, the gold membership will
              be free for you for the remainder of the relevant period of your membership.
            </p>

            <p class="w-full leading-relaxed">
              At the end of the period your membership will automatically cancel. To renew, you need to login to
              SellMyLivestock and go to Memberships in Settings where you can choose your new plan. Your current
              memberships is most similar to the new Gold membership.
            </p>
          </template>
        </UtilAccordianItem>

        <UtilAccordianItem>
          <template #title>How do I get in touch with you for help?</template>

          <template #content>
            <p class="w-full leading-relaxed">
              You are welcome to reach out to our support team via our customer support email on
              <a href="mailto:support@sellmylivestock.co.uk">support@sellmylivestock.co.uk</a>
              where one of our team will come back to you within 3-5 days. Please note that if you require help
              with upgrading or downgrading your membership offline, there will be a £25 administration fee that
              needs to be paid in advance of the support.
            </p>

            <p class="w-full leading-relaxed">
              Our Platinum members have access to a dedicated account manager with telephone support. If you’re
              interested in our Platinum membership, get in touch and one of the sales team will call you back.
            </p>
          </template>
        </UtilAccordianItem>
      </div>

      <div class="text-center">
        <UtilButton
          @click="$emit('choose-plan')"
          :block="$breakpoint.xs"
          color="primary"
          class="mx-auto mt-8 font-medium"
        >
          Become a member
        </UtilButton>
      </div>
    </div>
  </div>
</template>

<script>
import UtilAccordianItem from '@/components/utils/UtilAccordianItem'
import UtilButton from '@/components/utils/UtilButton'

export default {
  name: 'WidgetFaqMPremiumMembership',
  components: {
    UtilAccordianItem,
    UtilButton
  }
}
</script>
